import perfect from "../feature/perfect.png";
import dashftrs from "../feature/dashftrs.webp";

function FeaturesROI() {
    return (
        <section className="roi-section py-5 pt-6indx0 pt-0" id="retarget-benefits">

            <div className="container">
                <div className="row">
                    {/* Heading */}

                    <div className="roi-header mw800">

                        <h2 className="roi-title">
                            Enterprise-grade customer intelligence{" "}
                            <span className="highlight">
                                that drives repeat revenue.
                            </span>
                        </h2>

                    </div>

                    {/* Dashboard Grid */}

                    <div className="roi-grid">

                        {/* Stat Card 1 */}

                        <div className="roi-card blue-card card-pattern">

                            <span className="pattern-ring ring-3"></span>
                            <span className="pattern-ring ring-4"></span>

                            <div className="roi-number">
                                1M+
                            </div>

                            <div className="roi-label">
                                Orders Processed
                            </div>

                        </div>

                        {/* Main Card */}

                        <div className="roi-card roi-main-card">

                            <div className="main-left">

                                <span className="dott-mini stat-top-bg-success"></span>

                                <h4 className="fw800 mt-3">
                                    Understand buying patterns
                                </h4>

                                <p className="font90x">
                                    Learn when and why customers buy using timing,
                                    habits and triggers shaped by previous interactions.
                                </p>

                            </div>

                            <div className="main-right">

                                <div className="chart-area">

                                    <img className="rounded-4 w-100"
                                        src={dashftrs}
                                        alt=""
                                    />

                                </div>

                                <div className="segment-box segment-yellow">
                                    High Intent Buyers
                                </div>

                                <div className="segment-box segment-red">
                                    Churn Risk Customers
                                </div>

                                <div className="segment-box segment-dgreen">
                                    Weekly Repeat Purchasers
                                </div>

                            </div>

                        </div>

                        {/* Feature Card */}

                        <div className="roi-card green-card">                            

                            <h4 className="fw800 mb-3">
                                Trigger timely interactions
                            </h4>

                            <p className="mb-4">
                                Reach customers at the perfect moment with tailored
                                messages.
                            </p>

                            <div className="interaction-image">

                                <img className="rounded-4 w-100"
                                    src={perfect}
                                    alt=""
                                />

                            </div>

                        </div>

                        {/* Bottom Left */}

                        <div className="roi-card feature-card segment-yellow">

                            <div>

                                <h4 className="fw800">
                                    Build adaptive segments
                                </h4>

                                <p>
                                    Continuously group customers using behavior,
                                    spend and intent signals.
                                </p>

                                <div className="segment-preview">

                                    <div className="segment-pill segment-purple">
                                        VIP Customers
                                    </div>

                                    <div className="segment-pill segment-blue">
                                        Weekly Buyers
                                    </div>

                                    <div className="segment-pill segment-green">
                                        High Spend
                                    </div>

                                </div>

                            </div>

                        </div>

                        <div className="roi-card feature-card feature-card-optimization bg-lblue">

                            <div className="row align-items-center">

                                {/* LEFT SIDE */}

                                <div className="col-lg-7 col-md-12 mb-4 mb-lg-0">

                                    <h4 className="fw800">
                                        Optimize what works
                                    </h4>

                                    <p className="mb-0 font90x">
                                        Understand what drives repeat purchases and focus on the channels generating revenue.
                                    </p>

                                </div>

                                {/* RIGHT SIDE */}

                                <div className="col-lg-5 col-md-12">

                                    <div className="optimization-dashboard bg-white p-3 rounded-4">

                                    <div className="optimization-winner">

                                        <span className="winner-label fw-bold">
                                            Top Performing Channel
                                        </span>

                                        <div className="winner-row">

                                            <div className="winner-icon">
                                                💬
                                            </div>

                                            <div>

                                                <h5 className="fw-bold">WhatsApp Campaigns</h5>

                                                <div className="text-muted font8">
                                                    Generated 52% more repeat orders
                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                    <div className="channel-performance">

                                        <div className="channel-row">

                                            <span className="font8">Email</span>

                                            <div className="bar">
                                                <div className="fill email"></div>
                                            </div>

                                            <strong>31%</strong>

                                        </div>

                                        <div className="channel-row">

                                            <span className="font8">SMS</span>

                                            <div className="bar">
                                                <div className="fill sms"></div>
                                            </div>

                                            <strong>18%</strong>

                                        </div>

                                        <div className="channel-row">

                                            <span className="font8">WhatsApp</span>

                                            <div className="bar">
                                                <div className="fill whatsapp"></div>
                                            </div>

                                            <strong>52%</strong>

                                        </div>

                                    </div>

                                </div>

                                </div>

                            </div>

                        </div>

                        {/* Stat Card 2 */}

                        <div className="roi-card purple-card card-pattern">
                            
                            <span className="pattern-ring ring-3"></span>
                            <span className="pattern-ring ring-4"></span>
                            
                            <div className="roi-number">
                                29%
                            </div>

                            <div className="roi-label">
                                Average Repeat Rate
                            </div>

                        </div>

                    </div>
                </div>

            </div>

        </section>
    );
}

export default FeaturesROI;